module.exports = __webpack_public_path__ + "img/zfcg_01.eab39362.png";